import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
  TREE,
  BRANCH,
} from 'fc-model-soil-test-results'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import { composeFetchSaga } from 'fc-fetch-worker'

import worker from 'fc-wrkr-soil-test-results'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize: function initialize (controller) {
    const terminate = function terminate () {
      if (worker) {
        console.warn('Terminating Soil Test Results Worker')
        worker.terminate()
      }
    }

    return new Promise((resolve) => {
      terminate()

      console.warn('Initializing Soil Test Results Worker')
      resolve({
        terminate,
        handleFetch: composeFetchSaga({
          getWorker: function (): Worker {
            return worker.getWorker()
          },
        }),
      })
    })
  },
})
